import Vue           from 'vue';
import Vuex          from 'vuex';
import alerts        from './alerts/';

import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		alerts
	},
	plugins: [createPersistedState({
		paths: ['alerts.restId']
	})]
});



// WEBPACK FOOTER //
// ./src/store/index.js